<template>
  <div id="styledButton" :class="[{down: isDown}]">
      <router-link class='buttonLabel' @click.native="pressed" :to="{path: route}">
        {{ $t(label) }}
      </router-link>
  </div>
</template>

<script>


export default {
  name: 'StyledButton',
  props:{
     label: String,
     route: String
  },
  data(){
    return{
        isDown: false
    }
  },
  methods: {
    pressed(){
      this.isDown = true;

      setTimeout(() => {
        this.$emit("pressed");
        this.isDown = false;
      }, 250);
    }
  },
}
</script>

<style scoped>
#router{
  text-decoration: none
}

#styledButton{
  display: inline;
  background-color: #00b74f;
  border-radius: 7px;
  padding: 10px;
}

.buttonLabel{
  display: inline;
  font-family: sans-serif;
  font-size: 16px;
  line-height: 16px;
  text-decoration: none;
  font-weight: normal;
  text-transform: uppercase;
  color: white;
  text-align: center;
    padding: 12px;

}

/* not currently working */
.down{
  animation: pressAnimation 500ms ease-in-out
}

@keyframes pressAnimation {
  50%  {
    transform: scale(.9);
    }
  100% {
    transform: scale(1);
    }
}

</style>
